import { useEffect, useRef, useState } from "react";

export const SPEEDS = [1, 2, 5, 10, 25, 50, 100, 250, 1000];
export const autoSpeed = ([lo, hi]) => SPEEDS.find((s) => (hi - lo) / s <= 25) ?? SPEEDS[SPEEDS.length - 1];

export function usePlayback(time, setTime, range) {
  const [playing, setPlaying] = useState(false);
  const [speed, setSpeed] = useState(null);
  const ref = useRef(time);
  if (!playing) ref.current = time;
  const sp = speed ?? autoSpeed(range);
  const [lo, hi] = range;

  useEffect(() => {
    if (!playing) return undefined;
    let raf, last = performance.now();
    const tick = (now) => {
      const cur = ref.current;
      const next = cur.t + ((now - last) / 1000) * sp;
      last = now;
      if (next >= hi) {
        ref.current = { ...cur, t: hi };
        setTime(ref.current);
        setPlaying(false);
        return;
      }
      ref.current = { ...cur, t: next };
      setTime(ref.current);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [playing, sp, hi, setTime]);

  const play = (start) => {
    const base = start || ref.current;
    if (!base) return;
    ref.current = base.t >= hi || base.t < lo ? { ...base, t: lo } : base;
    setTime(ref.current);
    setPlaying(true);
  };
  const pause = () => {
    if (!playing) return;
    setPlaying(false);
    if (ref.current) setTime({ ...ref.current, t: Math.floor(ref.current.t) });
  };
  const restart = () => play({ ...ref.current, t: lo });
  return { playing, play, pause, restart, speed: sp, setSpeed };
}

export function pulseWindow(playing, speed) {
  return playing ? Math.max(speed * 2, 1) : 1;
}

export function recentEvents(events, t, win) {
  if (t == null) return [];
  return events
    .map((e) => ({ e, age: t - e.timestamp_int }))
    .filter(({ age }) => age >= 0 && age < win)
    .sort((a, b) => a.age - b.age);
}
